import { ReactElement, Suspense } from "react";
import TopBar from "./features/topBar/topBar";
import { Outlet } from "react-router-dom";

export default function Root(): ReactElement {
  return (
    <>
      <TopBar />
      <Suspense fallback={"Inhalt wird geladen"}>
        <Outlet />
      </Suspense>
    </>
  );
}
